export default {
    noProgram: {
        title: "Nenhum programa disponível",
        description: "Este estabelecimento não tem um programa de benefícios ativo no momento.",
    },
    notFound: {
        title: "Estabelecimento não disponível",
        description: "Confira se o link está correto.",
    },
    error: {
        title: "Não foi possível carregar",
        description: "Verifique sua conexão e tente novamente.",
        retry: "Tentar novamente",
    },
};
